import React, {ReactNode, useEffect} from 'react';
import {useAuth0} from '@auth0/auth0-react';
import rollbar from '~/vendor/rollbar';

export const Auth0SilentAuth: React.FC<{children: ReactNode}> = ({
  children
}) => {
  const {getAccessTokenSilently} = useAuth0();

  useEffect(() => {
    const authenticateSilently = async () => {
      try {
        await getAccessTokenSilently();
      } catch (e: any) {
        if (e.message === 'Login required') {
          return;
        }
        rollbar.warning(`Auth0 silent authentification failed: ${e}`);
      }
    };
    authenticateSilently();
  }, [getAccessTokenSilently]);

  return <>{children}</>;
};
